import React, { useContext, useEffect } from "react";
import { RouteContext } from "../outboundAmzl/context/RouteContextProvider";
import { OutboundFilterContext } from "../outboundAmzl/context/OutboundFilterContext";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import {
  getBaseUrl,
  getRouteByStatusCount,
  parseCapabilitiesResponse,
} from "../outboundAmzl/util/Util";
import { FormattedMessage } from "react-intl";
import {
  getDocumentURL,
  getNodeCapability,
} from "../handler/ParentDataHandler";
import { getRefreshInterval } from "../overview/utils/utils";

const RouteWaveView = () => {
  const { viewModel, dispatch } = useContext(RouteContext);
  const { viewModelF, dispatchF } = useContext(OutboundFilterContext);

  let routeList = viewModel.routeList;

  const filterCluster = (route) => {
    if (viewModelF.cluster.length === 0) {
      return true;
    }
    let result = false;
    viewModelF.cluster.forEach((cluster) => {
      if (route.routeCode.includes(cluster)) {
        result = true;
      }
    });
    return result;
  };
  const filterType = (route) => {
    if (viewModelF.driverType.length === 0) {
      return true;
    }
    let result = false;
    viewModelF.driverType.forEach((driverType) => {
      if (route.routeType.includes(driverType)) {
        result = true;
      }
    });
    return result;
  };
  const filterDeparture = (route) => {
    if (viewModelF.departure.length === 0) {
      return true;
    }
    let result = false;
    viewModelF.departure.forEach((departure) => {
      if (route.routeSLA.includes(departure)) {
        result = true;
      }
    });
    return result;
  };

  routeList = routeList
    .filter((route) => filterCluster(route))
    .filter((route) => filterType(route))
    .filter((route) => filterDeparture(route));

  const routeWaveList = [];
  routeList.forEach((route) => {
    const wave = routeWaveList.find((wave) => {
      return wave.name === route.routeSLA;
    });
    if (wave) {
      wave.routeList.push(route);
    } else {
      routeWaveList.push({
        name: route.routeSLA,
        routeList: [route],
      });
    }
  });

  const getRouteData = () => {
    Promise.all([getDocumentURL(), getNodeCapability()]).then((result) => {
      dispatch({
        type: "LOAD_VIEW",
        data: {
          dispatcher: dispatch,
          filterDispatcher: dispatchF,
          baseUrl: getBaseUrl(result[0]),
          capability: parseCapabilitiesResponse(result[1]),
        },
      });
    });
  };

  useEffect(() => {
    getRouteData();
    const interval = setInterval(() => {
      if (!document.hidden) {
        getRouteData();
      }
    }, getRefreshInterval());
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <Row widths={["grid-12"]} alignmentVertical="top" spacingInset="large">
        <div>
          <Heading level={2} type="h400" alignment="left">
            <FormattedMessage
              id="outboundAMZL.routeWaves"
              defaultMessage="Route Waves"
            />
          </Heading>
          <br />
          <Table headerRows={1} spacing="small">
            <TableRow>
              <TableCell>Wave</TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAZML.totalRoutes"
                  defaultMessage="Total Routes"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAZML.pendingPick"
                  defaultMessage="Pending Pick"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAZML.pendingStage"
                  defaultMessage="Pending Stage"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.pendingDepart"
                  defaultMessage="Pending Depart"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.departedRoutes"
                  defaultMessage="Departed Routes"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.sidelinedRoutes"
                  defaultMessage="Sidelined Routes"
                />
              </TableCell>
            </TableRow>
            {routeWaveList.map((wave) => (
              <TableRow key={wave.name}>
                <TableCell>{wave.name}</TableCell>
                <TableCell alignmentHorizontal="right">
                  {wave.routeList.length}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteByStatusCount("Picked", wave.routeList)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteByStatusCount("Staged", wave.routeList)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteByStatusCount("Pending Departed", wave.routeList)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteByStatusCount("Departed", wave.routeList)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteByStatusCount("Sidelined", wave.routeList)}
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </div>
      </Row>
    </div>
  );
};

export default RouteWaveView;



// WEBPACK FOOTER //
// ./src/components/outboundOverview/RouteWaveView.js